import { CSSProperties, ReactNode, useState } from 'react';

import { CheckboxIcon } from 'icons';

import { Label, Base } from './styles';
import styled from 'styled-components';

import { colors } from '../../styles/colors';
import { Link } from 'react-router-dom';

export const Checkbox = (props: {
  label?: string;
  onClick?: (event: any) => void;
  checked?: boolean|null;
  disabled?: boolean;
  checkableItem?: { checked?: boolean };
  size?: number;
  alignLeft?: boolean;
  borderRadius?: number;
  link?: string;
  style?: CSSProperties;
  color?: string;
  children?: ReactNode;
  tabIndex?: number
}): JSX.Element => {
  const {
    label, onClick, checked, disabled, checkableItem, alignLeft, size, borderRadius, link, style, tabIndex, ...extraProps
  } = props;
  const isChecked = checked || (checkableItem && checkableItem.checked);
  const [, setState] = useState({});
  function checkHandler() {
    if (checkableItem) {
      checkableItem.checked = !checkableItem.checked;
      setState({});
    }
  }
  return (
    <Label
      style={{
        display: 'flex',
        flexFlow: 'row nowrap',
        justifyContent: alignLeft ? 'start' : 'center',
        ...style,
      }}
      {...extraProps}
    >
      <Base
        role="checkbox"
        aria-checked={!!isChecked}
        data-state={isChecked ? 'checked' : 'unchecked'}
        style={{ cursor: 'pointer', borderRadius }}
        onClick={onClick || (checkableItem && checkHandler)}
        size={size}
        checked={isChecked}
        disabled={disabled}
        tabIndex={tabIndex}
        {...tabIndex !== undefined && ({
          onKeyDown: (e) => {
            if (e.key === ' ' || e.key === 'Enter') {
              if (onClick) {
                onClick(e);
                return;
              }

              if (checkableItem) {
                checkHandler();
              }
            }
          },
        })}
      >
        {isChecked ? <CheckboxIcon aria-label="checked" size={size} /> : null}
      </Base>
      {label && !link
      && (
      <span
        style={{
          cursor: 'pointer',
          paddingLeft: '10px',
          hyphens: 'auto',
        }}
        onClick={onClick || (checkableItem && checkHandler)}
      >
          {label}
      </span>
      )}
      {link && <StyledLink to={link}>{label}</StyledLink>}

    </Label>
  );
};

const StyledLink = styled(Link)`
  color: ${colors.Grey400};
  margin: 0 8px;
  &:hover {
    text-decoration: underline;
    color: ${colors.Grey400};
  }
`;
